import React from 'react';
import { StyledLabel, StyledRadioButton, StyledContentWrap } from './RadioButton.style';

function RadioButton(props) {
    const { children, ...otherProps } = props;
    return (
        <StyledLabel>
            <StyledRadioButton {...otherProps} type="radio" />
            <StyledContentWrap>{children}</StyledContentWrap>
        </StyledLabel>
    );
}

export { RadioButton };
